/* global FormData */
import OButton from 'components/reusable/OButton'
import useToastContext from 'hooks/useToastContext'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { apiPost, apiPut } from '../../utils/apiFetch'
import { useTranslation } from 'react-i18next'
import { startCase } from 'lodash'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import 'react-phone-input-2/lib/style.css'
import { useLocation } from 'react-router-dom'

const AddEditModal = ({ setAddEditModal, allAddress, item }) => {
  const { t } = useTranslation()
  const location = useLocation()
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      name: item?.name,
      nameAr: item?.nameAr,
      latitude: item?.location?.coordinates[1],
      longitude: item?.location?.coordinates[0]
    }
  })
  const notification = useToastContext()

  const onSubmit = async formData => {
    try {
      let apiPath
      let data
      if (location.pathname === '/city') {
        apiPath = '/v1/admin/cities'
        if (item) {
          data = await apiPut(apiPath + '/' + item?._id, formData)
        } else {
          data = await apiPost(apiPath, formData)
        }
      } else if (location.pathname === '/city/community') {
        apiPath = '/v1/admin/communities'
        if (item) {
          data = await apiPut(apiPath + '/' + item?._id, {
            ...formData,
            cityId: location.state?.id
          })
        } else {
          data = await apiPost(apiPath, {
            ...formData,
            cityId: location.state?.id
          })
        }
      } else if (location.pathname === '/city/subCommunity') {
        apiPath = '/v1/admin/sub-communities'
        if (item) {
          data = await apiPut(apiPath + '/' + item?._id, {
            ...formData,
            communityId: location.state?.id
          })
        } else {
          data = await apiPost(apiPath, {
            ...formData,
            communityId: location.state?.id
          })
        }
      }

      if (data?.data?.success) {
        setAddEditModal(false)
        allAddress()
        notification.success(data?.data?.message)
        reset()
      } else {
        notification.error(data?.data?.message)
      }
    } catch (err) {
      console.error('err:', err)
    }
  }

  useEffect(() => {}, [])
  return (
    <div>
      <>
        <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
          <div className='relative my-6  w-full max-w-[1150px] mx-auto'>
            <div className='sm:py-4 sm:px-2 py-8 px-7 '>
              <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
                <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                  <h3 className='text-xl font-semibold'>
                    Add {startCase(location.pathname.replace('/', ''))}
                  </h3>
                  <button
                    className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                    onClick={() => setAddEditModal(false)}
                  >
                    <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                      ×
                    </span>
                  </button>
                </div>
                <div className='relative p-6 flex-auto'>
                  <div className='grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2'>
                    <div className='px-2'>
                      <OInputField
                        wrapperClassName='relative z-0 mb-6  w-full group'
                        name='name'
                        inputLabel={
                          <>
                            {startCase(location.pathname.replace('/', ''))}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        autoFocus
                        register={register('name', {
                          required: `Please enter ${location.pathname.replace(
                            '/',
                            ''
                          )} name.`,
                          validate: value => {
                            return !value ? 'White spaces not allowed.' : true
                          }
                        })}
                        errors={errors}
                      />
                    </div>

                    <div className='px-2'>
                      <OInputField
                        wrapperClassName='relative z-0 mb-6  w-full group'
                        name='nameAr'
                        inputLabel={
                          <>
                            {startCase(location.pathname.replace('/', ''))}{' '}
                            {t('O_ARABIC')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        register={register('nameAr', {
                          required: `Please enter ${location.pathname.replace(
                            '/',
                            ''
                          )} name.`,
                          validate: value => {
                            return !value ? 'White spaces not allowed.' : true
                          }
                        })}
                        errors={errors}
                      />
                    </div>

                    <div className='px-2'>
                      <OInputField
                        wrapperClassName='relative z-0   w-full group'
                        name='latitude'
                        inputLabel={
                          <>
                            {t('O_LATITUDE')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='number'
                        register={register('latitude', formValidation.latitude)}
                        errors={errors}
                      />
                    </div>
                    <div className='px-2'>
                      <OInputField
                        wrapperClassName='relative z-0   w-full group'
                        name='longitude'
                        inputLabel={
                          <>
                            {t('O_LONGITUDE')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='number'
                        register={register(
                          'longitude',
                          formValidation.longitude
                        )}
                        errors={errors}
                      />
                    </div>
                  </div>
                </div>
                <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                  <button
                    className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                    type='button'
                    onClick={() => setAddEditModal(false)}
                  >
                    {t('O_BACK')}
                  </button>
                  <OButton
                    label={<>{t('O_ADD')}</>}
                    type='submit'
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='opacity-25 fixed inset-0 z-40 bg-black' />
      </>
    </div>
  )
}

export default AddEditModal
